import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useHuaShuSore } from '@/store/modules/haushu'
import { useIndexSore } from '@/store/modules/app'
import { storeToRefs } from 'pinia'

NProgress.configure({ showSpinner: false })
router.beforeEach((to, from, next) => {
    const store = useHuaShuSore()
    const Indextore = useIndexSore()
    const { lineType, sysType } = storeToRefs(store)
    const { subMenuId, subMenuState, isBreadCrumb, isGrap } = storeToRefs(Indextore)
    if (from.path === '/grapView') {
        isGrap.value = true
    } else {
        isGrap.value = false
    }
    from.fullPath === '/lineManage' ? (lineType.value = '2') : (lineType.value = '1')
    from.fullPath === '/lineManage' ? (sysType.value = '2') : (sysType.value = '1')

    if (to.fullPath === '/lineManage') {
        isBreadCrumb.value = true
    } else {
        isBreadCrumb.value = false
    }
    if (subMenuState.value) {
        subMenuState.value.forEach(item => {
            if (to.fullPath == item.menu_url) {
                subMenuId.value = item.id
            }
        })
    }

    NProgress.start()
    next()
})

router.afterEach(() => {
    NProgress.done()
})
